import MazBtn from "./_main.vue";

MazBtn.install = (Vue) => {
  Vue.component(MazBtn.name, MazBtn);
};

export default MazBtn;
